<section class="thankyou-page">
  <div class="thankyou-card">
    <div class="icon-wrapper">
      🎉
    </div>

    <h1 class="title">Köszönjük a feliratkozást!</h1>
    <p class="subtitle">
      A <strong>kuponkódot</strong> és a <strong>QR-kódot</strong> e-mailben elküldtük neked.
    </p>

    <div class="info-box">
      <p>
        <strong>Fontos:</strong> Ha nem találod az e-mailt, ellenőrizd a <em>Spam</em> vagy
        <em>Promóciók</em> mappát is!
      </p>
      <p>
        A QR-kódot vásárláskor bemutatva <strong>10% kedvezményt</strong> kapsz az üzletben,
        és további meglepetések is várhatnak rád 🌷
      </p>
    </div>

    <div class="cta-wrapper">
      <a routerLink="/" class="btn-primary">Vissza a főoldalra</a>
    </div>
  </div>
</section>
